
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ButtonRow from '@/components/profile/ButtonRow.vue';
import CountrySelect from '@/components/form/CountrySelect.vue';
import LocaleField from '@/components/form/LocaleField.vue';
import RestaurantTypeSelect from '@/components/form/RestaurantTypeSelect.vue';
import PhoneSelect from '@/components/form/PhoneSelect.vue';

@Component({
  components: {
    ButtonRow,
    CountrySelect,
    PhoneSelect,
    LocaleField,
    RestaurantTypeSelect,
  },
})
export default class FormGroup extends Vue {
  valid = true;

  @Prop(String)
  name!: string;

  @Prop(Object)
  group!: any;

  @Prop(Object)
  profile!: any;

  @Emit('submit')
  submit() {}

  @Emit('cancel')
  cancel() {}

  @Emit('setField')
  setField(name: string, value: string): any {
    return { name, value };
  }

  onValidate(name: string, valid: boolean) {
    this.valid = valid;
  }

  getInputComponent(field: any) {
    switch (field.type) {
      case 'country':
        return 'country-select';
      case 'tel':
        return 'phone-select';
      case 'locale':
        return 'locale-field';
      case 'restaurant-type':
        return 'restaurant-type-select';
      default:
        return 'b-input';
    }
  }
}
